<template>
  <div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>Latitud</label>
          <input type="number" step="any" v-model.number="reportedCenter.lat" class="form-control" />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Longitud</label>
          <input type="number" step="any" v-model.number="reportedCenter.lng" class="form-control" />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Radio</label>
          <input type="number" v-model="radius" class="form-control" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <gmap-map
          :center="center"
          :zoom="15"
          style="width: 100%; height: 400px"
          ref="map"
          @center_changed="update('reportedCenter', $event)"
          @bounds_changed="update('bounds', $event)"
        >
          <gmap-circle
            v-if="displayCircle"
            :center="reportedCenter"
            :bounds="circleBounds"
            :radius="parseFloat(radius)"
            :options="{ editable: true }"
            @radius_changed="editarCirculo('radius', $event)"
            @bounds_changed="editarCirculo('bounds', $event)"
          ></gmap-circle>
        </gmap-map>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TepBloqueMapCir",
  props: {
    entity: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      center: { lat: 4.651371, lng: -74.071509 },
      reportedCenter: { lat: 4.651371, lng: -74.071509 },
      displayCircle: true,
      circleBounds: {},
      radius: 1000,
    };
  },
  methods: {
    update(field, event) {
      if (field === "reportedCenter") {
        this.reportedCenter = { lat: event.lat(), lng: event.lng() };
      }
    },
    editarCirculo(prop, value) {
      if (prop === "radius") this.radius = value;
      if (prop === "bounds") this.radius = value;
    },
    initCir() {
      if (
        this.entity &&
        this.entity.geocerca &&
        this.entity.geocerca.latitud !== null &&
        this.entity.geocerca.longitud !== null
      ) {
        this.reportedCenter = {
          lat: parseFloat(this.entity.geocerca.latitud),
          lng: parseFloat(this.entity.geocerca.longitud),
        };
        this.center = { ...this.reportedCenter };
        this.radius = parseFloat(this.entity.geocerca.radio);
      }
    },
  },
  mounted() {
    this.initCir();
  },
};
</script>
